// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "/" + "1faa179dfb20d0a3f5a0" + ".js";
};